import React from 'react';
import cc from 'classcat';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Container } from '../../../grid';
import Icon from '../../atoms/icon';

interface PageHeaderProps {
  className?: string;
  text?: string;
  icon?: FontAwesomeIconProps['icon'];
}

/**
 * The height defined on the Container brings this component
 * height in line with the side navigation item height
 */

const PageHeader: React.FC<PageHeaderProps> = ({
  children,
  text,
  icon,
  className
}) => {
  const classes = cc(['bg-white', className ? className : undefined]);
  return (
    <div className={classes}>
      {children ? (
        children
      ) : (
        <Container fluid style={{ height: '58px' }}>
          <h1 className="font-serif text-serif-lg inline-block align-middle">
            {icon && <Icon title={false} className="mr-2" icon={icon} />}
            {text}
          </h1>
        </Container>
      )}
    </div>
  );
};

export default PageHeader;
